var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIIcoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;fill-rule:evenodd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Zas\xF3b 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_2",
    "data-name": "Warstwa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "podmianka_I",
    "data-name": "podmianka I"
  }, /*#__PURE__*/React.createElement("g", {
    id: "info_icon",
    "data-name": "info icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    className: "cls-1",
    d: "M6,11.4A5.4,5.4,0,1,1,11.4,6,5.4,5.4,0,0,1,6,11.4M6,0a6,6,0,1,0,6,6A6,6,0,0,0,6,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    className: "cls-1",
    d: "M6.6,3.6A.6.6,0,1,1,6,3a.6.6,0,0,1,.6.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    className: "cls-1",
    d: "M5.7,5.8V9.2c0,.22.13.4.3.4s.3-.18.3-.4V5.8c0-.22-.13-.4-.3-.4S5.7,5.58,5.7,5.8Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIIcoWhite);
export default __webpack_public_path__ + "static/media/i-ico-white.049fb77d746eb4ed5aded36fc21621a0.svg";
export { ForwardRef as ReactComponent };